<script>
  /**
   *  Mirror.svelte
   * ------------------------------------------------------------------
   * The large circle element used for Mirror, PhotoBooth, and Cartoon
   *
   */

  import { onMount, onDestroy, createEventDispatcher } from 'svelte';
  import { scale, fade, blur } from 'svelte/transition';

  export let stream;
  let canvasEl, videoEl, playing;

  onMount(() => {
    videoEl.srcObject = stream;
    canvasEl.width = 400;
    canvasEl.height = 400;
    const context = canvasEl.getContext('2d');
    playVideo();

    function drawFrame() {
      // context.drawImage(videoEl, -230, -110, 960, 720);
      context.drawImage(videoEl, -140, -40, 640, 480);
      playing = requestAnimationFrame(drawFrame);
    }
    function playVideo() {
      videoEl.play();
      requestAnimationFrame(drawFrame);
    }
  });

  onDestroy(() => {
    cancelAnimationFrame(playing);
    delete videoEl.srcObject;
  });
</script>

<div
  class="absolute left-1/2 top-1/2"
  style="width: 400px; height: 400px; margin-left: -200px; margin-top: -200px;"
  in:scale="{{ duration: 500 }}"
  out:scale>
  <canvas
    class="border-gray-400 border-8 rounded-full overflow-hidden"
 
    bind:this="{canvasEl}"></canvas>
  <video
    class="hidden rounded-full"
    style="border: 8px solid transparent"
    bind:this="{videoEl}"
    muted="muted"
    autoplay
    playsinline></video>
  <slot />
</div>
